module.exports = __webpack_public_path__ + "img/技术方案审核解析.2842821b.png";